var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClipboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 35,
    viewBox: "0 0 33 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8931 6.46753H24.5134C25.2083 6.46753 25.8748 6.76581 26.3662 7.29676C26.8576 7.82771 27.1337 8.54783 27.1337 9.2987V29.1169C27.1337 29.8678 26.8576 30.5879 26.3662 31.1188C25.8748 31.6498 25.2083 31.948 24.5134 31.948H8.79146C8.09651 31.948 7.43002 31.6498 6.93862 31.1188C6.44721 30.5879 6.17114 29.8678 6.17114 29.1169V9.2987C6.17114 8.54783 6.44721 7.82771 6.93862 7.29676C7.43002 6.76581 8.09651 6.46753 8.79146 6.46753H11.4118",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5829 3.63623H12.7219C11.9983 3.63623 11.4117 4.27001 11.4117 5.05181V7.88298C11.4117 8.66479 11.9983 9.29857 12.7219 9.29857H20.5829C21.3064 9.29857 21.893 8.66479 21.893 7.88298V5.05181C21.893 4.27001 21.3064 3.63623 20.5829 3.63623Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.d91d173169b94bedcd6edb7f41c82728.svg";
export { ForwardRef as ReactComponent };